import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiUrl } from '../config';

export const favoriteApi = createApi({
  reducerPath: 'favoriteApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl(),
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      const tkn = localStorage.getItem('tkn');
      
      if (token) {
        headers.set('Authorization', `${token}`);
      }
      if (tkn) {
        headers.set('Tkn', `${tkn}`);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Favorite'],
  endpoints: (builder) => ({
    getFavorites: builder.query({
      query: () => '/favorites',
      transformResponse: (response) => {
        return response.map(favorite => {
          if (typeof favorite.image === 'string') {
            try {
              const imageUrls = JSON.parse(favorite.image.replace(/\\/g, ''));
              return { ...favorite, image: imageUrls };
            } catch (error) {
              console.error('Image JSON parse edilemedi:', error);
              return favorite;
            }
          }
          return favorite;
        });
      },
      providesTags: ['Favorite'],
    }),
    
    addToFavorite: builder.mutation({
      query: (urunId) => ({
        url: '/favorites',
        method: 'POST',
        body: { urun_id: urunId },
      }),
      invalidatesTags: ['Favorite'],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Facebook Pixel event
          fbq('track', 'AddToWishlist');
        } catch (err) {
          console.error('Favorilere ekleme hatası:', err);
        }
      },
    }),

    removeFromFavorite: builder.mutation({
      query: (favoriteId) => ({
        url: `/favorites?id=${favoriteId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Favorite'],
    }),
  }),
});

export const {
  useGetFavoritesQuery,
  useAddToFavoriteMutation,
  useRemoveFromFavoriteMutation,
} = favoriteApi; 